import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export function useDeleteAgent({ folderId }: Input = {}) {
  const utils = trpc.useUtils();

  return trpc.agent.delete.useMutation({
    onSuccess() {
      utils.agent.list.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({ folderId });
      }
    },
  });
}
